const tipTapToText = node => {
    let text = [];

    if (node && node.content) {
        node.content.forEach(n => {
            if (n.text) {
                text.push(n.text);
            }
            if (n.content) {
                text.push(tipTapToText(n));
            }
        });
    }

    return text.join(' ');
};

export default tipTapToText;
